import { Address } from 'api/client-domain/client-domain.types';

export const assign = url => {
  if (window.Cypress) {
    window.mockAssign(url);
  } else {
    window.location.assign(url);
  }
};

export const formatAddress = (address: Address) => {
  return (
    address?.streetAddress1 + ', ' + address?.city + ' ' + address?.postalCode
  );
};
